export const ADD_NOISE = 'ADD_NOISE'
export const RESET_NOISE = 'RESET_NOISE'


export const addNoise = (noise) => {
    return {
        type: ADD_NOISE,
        noise
    }
}

export const resetNoise = () => {
    return {
        type: RESET_NOISE
    }
}


// WEBPACK FOOTER //
// ./src/actions/noise.js